import { COMING_SOON } from "@/entities/CreditBox/CreditBox.types";
import { Chip } from "@/ui";
import { useFlags } from "@/utils/flagsmith/useFlags";

export const ComingSoonSection = ({ title }: { title: string }) => {
    const flags = useFlags();
    const showComingSoon = flags.enabled("show-coming-soon-placeholders");

    if (!showComingSoon) {
        return null;
    }

    return (
        <div className="flex items-center gap-4">
            <h4 className="heading-m">{title}</h4>
            <Chip text={COMING_SOON} />
        </div>
    );
};
